import { Grid2, Typography } from "@mui/material";
import React from "react";
import { HandleSkeletion } from "../../../../utils/constants";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent";
import { SelectCreateCard } from "../../../home/style";
import { CustomizeSpan } from "../../../jobs/style";

const AnalyticsCard = ({ harizonAnalytics = [], isLoading }) => {
  return (
    <Grid2 container columnSpacing={2} rowSpacing={isLoading ? 0 : 3}>
      {isLoading ? (
        <>
          {Array.from({ length: 6 }).map((_, index) => (
            <CommonGrid2
              item
              size={{
                xs: 12,
                md: 4,
                sm: 12,
                lg: 2,
              }}
              gap={"5px"}
              display={"flex"}
              flexDirection={"row"}
            >
              <HandleSkeletion height={100} width={"100%"} />
            </CommonGrid2>
          ))}
        </>
      ) : (
        <>
          {Object.keys(harizonAnalytics).length !== 0 &&
            harizonAnalytics?.map(
              ({ name, value, percentage, decreament }, index) => (
                <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 2.4, xl: 2 }}>
                  <SelectCreateCard key={name + index} minHeight="100%">
                    <StyledSpaceBetweenBox alignItems="baseline">
                      <Typography
                        color="#5B738B"
                        variant="h6"
                        fontSize={"15px"}
                      >
                        {name}
                      </Typography>
                    </StyledSpaceBetweenBox>
                    <Typography variant="body6" marginTop={"10px"}>
                      {value}
                      {index === harizonAnalytics.length - 1 && (
                        <CustomizeSpan
                          fontSize={"13px"}
                          margin={"0px 0px 0px 5px"}
                          fontWeight={600}
                          color="#5B738B"
                        >
                          mins
                        </CustomizeSpan>
                      )}
                    </Typography>
                  </SelectCreateCard>
                </Grid2>
              )
            )}
        </>
      )}
    </Grid2>
  );
};

export default AnalyticsCard;
